import * as React from 'react';

function SvgUndo(props) {
    return (
        <svg version="1.1" id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            // xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px" y="0px"
            viewBox="0 0 60 60"
            style={{ enableBackground: "new 0 0 60 60" }}
            {...props}
        //   xml:space="preserve"
        >
            <g>
                <g>
                    <path class="st0" d="M30,53.8c-8.9,0-16.1-7.2-16.1-16.1V25h32.3v12.7C46.1,46.6,38.9,53.8,30,53.8z M17.3,28.4v9.2
			c0,7,5.7,12.7,12.7,12.7s12.7-5.7,12.7-12.7v-9.2H17.3z"/>
                </g>
                <g>
                    <path class="st0" d="M42.3,28.4h-23v-3.5h19.5v-6.4c0-4.9-4-8.9-8.9-8.9c-3,0-5.7,1.5-7.4,3.9l-2.9-1.9c2.3-3.4,6.1-5.4,10.2-5.4
			c6.8,0,12.3,5.5,12.3,12.3V28.4z"/>
                </g>
            </g>
        </svg>
    );
}

export default SvgUndo;
